// extracted by mini-css-extract-plugin
export default {"search":"DataTables_search__r5Z8I","searchBtn":"DataTables_searchBtn__skt8F"};